import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPelaksanaanAppealSubmittedProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPelaksanaanAppealSubmitted: React.FC<
  TDialogPelaksanaanAppealSubmittedProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-time-document.png"
            width={84}
            height={84}
          />

          <div className="space-y-4">
            <Text variant="display-sm">
              Perubahan sedang diajukan ke atasan
            </Text>
            <Text variant="body-lg" color="subdued">
              Status pengajuannya dapat dilihat di halaman Notifikasi atau cek
              lagi halaman ini nanti.
            </Text>
          </div>

          <div className="flex space-x-5">
            <Button
              data-testid="appeal-submitted-back-button"
              onClick={onClose}
              color="blue"
              size="lg"
              fullWidth
            >
              Saya mengerti
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
